// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.part-delivery-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(circle at top, #f4f7fb 0%, #e9eef5 45%, #dfe6ef 100%);
}

.part-delivery-card {
  width: 100%;
  max-width: 460px;
  padding: 28px;
  border-radius: 14px;
  background-color: #ffffff;
  box-shadow: 0 10px 30px rgba(35, 50, 84, 0.12);
}

.part-delivery-title {
  margin: 0 0 18px 0;
  color: #1f2d3d;
  font-size: 1.5rem;
  font-weight: 700;
}

.part-delivery-hint {
  margin: 0 0 16px 0;
  color: #526175;
  font-size: 0.95rem;
}

.part-delivery-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
}

.part-delivery-field label {
  margin-bottom: 6px;
  color: #2e3a4b;
  font-weight: 600;
}

.part-delivery-field input {
  border: 1px solid #c8d2e1;
  border-radius: 8px;
  font-size: 1rem;
  padding: 10px 12px;
  outline: none;
  transition: border-color 0.2s ease;
}

.part-delivery-field input:focus {
  border-color: #2b7fff;
}

.part-delivery-field textarea {
  border: 1px solid #c8d2e1;
  border-radius: 8px;
  font-size: 1rem;
  padding: 10px 12px;
  outline: none;
  transition: border-color 0.2s ease;
  resize: vertical;
  font-family: inherit;
}

.part-delivery-field textarea:focus {
  border-color: #2b7fff;
}

.part-delivery-submit {
  width: 100%;
  border: none;
  border-radius: 8px;
  margin-top: 8px;
  padding: 11px 12px;
  background-color: #2353b8;
  color: #ffffff;
  font-size: 0.98rem;
  font-weight: 700;
  cursor: pointer;
}

.part-delivery-submit:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.part-delivery-message {
  margin-top: 12px;
  font-size: 0.92rem;
}

.part-delivery-message.success {
  color: #0f8a42;
}

.part-delivery-message.error {
  color: #b52828;
}

@media (max-width: 600px) {
  .part-delivery-card {
    padding: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/part-delivery/PartDeliveryPage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iFAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,8CAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,kCAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;AACF","sourcesContent":[".part-delivery-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: radial-gradient(circle at top, #f4f7fb 0%, #e9eef5 45%, #dfe6ef 100%);\n}\n\n.part-delivery-card {\n  width: 100%;\n  max-width: 460px;\n  padding: 28px;\n  border-radius: 14px;\n  background-color: #ffffff;\n  box-shadow: 0 10px 30px rgba(35, 50, 84, 0.12);\n}\n\n.part-delivery-title {\n  margin: 0 0 18px 0;\n  color: #1f2d3d;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.part-delivery-hint {\n  margin: 0 0 16px 0;\n  color: #526175;\n  font-size: 0.95rem;\n}\n\n.part-delivery-field {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 14px;\n}\n\n.part-delivery-field label {\n  margin-bottom: 6px;\n  color: #2e3a4b;\n  font-weight: 600;\n}\n\n.part-delivery-field input {\n  border: 1px solid #c8d2e1;\n  border-radius: 8px;\n  font-size: 1rem;\n  padding: 10px 12px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.part-delivery-field input:focus {\n  border-color: #2b7fff;\n}\n\n.part-delivery-field textarea {\n  border: 1px solid #c8d2e1;\n  border-radius: 8px;\n  font-size: 1rem;\n  padding: 10px 12px;\n  outline: none;\n  transition: border-color 0.2s ease;\n  resize: vertical;\n  font-family: inherit;\n}\n\n.part-delivery-field textarea:focus {\n  border-color: #2b7fff;\n}\n\n.part-delivery-submit {\n  width: 100%;\n  border: none;\n  border-radius: 8px;\n  margin-top: 8px;\n  padding: 11px 12px;\n  background-color: #2353b8;\n  color: #ffffff;\n  font-size: 0.98rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.part-delivery-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.part-delivery-message {\n  margin-top: 12px;\n  font-size: 0.92rem;\n}\n\n.part-delivery-message.success {\n  color: #0f8a42;\n}\n\n.part-delivery-message.error {\n  color: #b52828;\n}\n\n@media (max-width: 600px) {\n  .part-delivery-card {\n    padding: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
